module.exports = __webpack_public_path__ + "img/双倍佣金.2356f475.svg";